export default class extends HTMLElement {
  constructor() {
    super();
    console.log('Init DSBAudio');
    this.audio = {};
    this.hooks = {};
    this.audio_meta=false;
    this.delegate=false;
    this.usingGlobalObject=false;
    this.allowDestructor = true;
    this.registeredListners=[];
    this.player = false;
  }

  disconnectedCallback()
  {
    this._log('debug','disconnectedCallback','Init');
    if(this.allowDestructor)
    {
      this._log('debug','disconnectedCallback','Resetting');
      this.action('reset');
    }

    for(let i=0;i<this.registeredListners.length;i++)
    {
      try
      {
        if('type' in this.registeredListners[i] && 'object' in this.registeredListners[i])
        {
          switch(this.registeredListners[i].type)
          {
            default:

              break;
          }
        }
      }
      catch(ex)
      {
        this._log('error','disconnectedCallback','Fatal error',ex,this.registeredListners[i]);
      }

    }
  }

  setDestructor(value)
  {
    this.allowDestructor=value;
  }

  get src() {
      return this.getAttribute('type');
  }

  set src(newValue){
      this.setAttribute('src', newValue);
  }

  get src() {
      return this.getAttribute('type');
  }

  get service() {
      return this.getAttribute('service');
  }

  set service(newValue){
      this.setAttribute('service', newValue);
  }

  get post_id() {
      let post_id = this.getAttribute('post_id');
      return post_id;
  }

  async getEndpoint()
  {
    this._log('debug','getEndpoint');
    let url = '';
    try
    {
      if(this.post_id!==null && !isNaN(this.post_id))
      {
        if(this.service == 'text-to-speech')
        {
            url = 'speech_by_postid/'+this.post_id+'.mp3';

            let is_loggedin = await this.dsbClient.user.is_loggedin('',false,false);
            this._log('debug','getEndpoint','is logged in '+is_loggedin);
            if(!is_loggedin)
            {
                url = 'public_speech_by_postid/'+this.post_id+'.mp3';
            }

            if(!this.audio_meta)
            {
              let _audio_meta = {};
              this.audio_meta={};
              if(!is_loggedin)
              {
                let post = await this.dsbClient.content.get('static','public_json_by_id/'+this.post_id);
                if(post.state && post.state=='success')
                {
                  _audio_meta = (Array.isArray(post.data)?post.data[0]:post.data);
                }
              }
              else
              {
                let post = await this.dsbClient.content.get('static','json_by_id/'+this.post_id);
                if(post.state && post.state=='success')
                {
                  _audio_meta = (Array.isArray(post.data)?post.data[0]:post.data);
                }
              }
              if('id' in _audio_meta)
              {
                this.audio_meta.id=_audio_meta.id;
              }
              if('title' in _audio_meta)
              {
                this.audio_meta.title=_audio_meta.title;
              }
            }
        }
      }
      else
      {
        // TODO add unknown audio path
        url = '';
      }

      return url;
    }
    catch(ex)
    {
      throw ex;
    }
  }

  set post_id(newValue){
      this.setAttribute('post_id', newValue);
  }

  set src(newValue){
      this.setAttribute('src', newValue);
  }

  setDSBClient(dsbClient){
      this.dsbClient=dsbClient;
  }

  setHooks(hooks)
  {
    this.hooks=hooks;
  }

  setDelegateElement(delegate)
  {
    this.delegate=delegate;
  }

  _log(type,source,message,data='')
  {
    let _message = 'dsb-app/DSBAUDIO('+this.service+'/'+this.post_id+')::'+source+'- '+message;
    switch(type)
    {
       case "debug":
         console.debug(_message,data);
        break;
      case "warning":
         console.warn(_message,data);
        break;
      case "error":
         console.error(_message,data);
        break;
      default:
          console.log(_message,data);
    }
  }

  async hasAudio()
  {
    if(!('available' in this.audio))
    {
      try
      {
        this.audio.available=false;
        if(await this.dsbClient.content.head(this.service,await this.getEndpoint()))
        {
          this.audio.available=true;
        }
      }
      catch(ex)
      {
        this._log('debug','hasAudio',ex);
      }
    }
    this._log('debug','hasAudio',this.audio.available);
    return this.audio.available;
  }

  async action(value,callback=false)
  {
    let _this = this;
    let _url = _this.service+'/'+await _this.getEndpoint();
    let app = window.fw_workbench.getApp();

    let function__getAudioObject = async function(create=false){
      let audio = false;
      if(typeof app == 'object' && 'getGlobalObject' in app)
      {
        let object_id = 'play';
        let object_type='audio';

        audio = await app.getGlobalObject(object_type,object_id);

        if(!audio)
        {
          if(create)
          {
            await app.setGlobalObject(object_type,object_id,await function__initAudio(),async function(object){
              if(typeof object === 'object' && 'source' in object && 'Ctx' in object)
              {
                object.source.stop(0);
                object.Ctx.close();
              }
            });
            audio = await app.getGlobalObject(object_type,object_id);
          }
        }

        console.log('function__getAudioObject',audio);
      }
      else
      {
        if(typeof _this.audio == 'object' && 'source' in _this.audio)
        {
          audio=_this.audio;
        }
        else
        {
          if(create)
          {
            _this.audio = await function__initAudio();
            audio=_this.audio;
          }
        }
      }
      return audio;

    }
    let function__destroyAudioObject = async function(){
      let audio = false;
      if(typeof app == 'object' && 'getGlobalObject' in app)
      {
        let object_id = 'play';
        let object_type='audio';

        audio = await app.getGlobalObject(object_type,object_id);

        if(audio)
        {
          await app.removeGlobalObject(object_type,object_id);
        }
      }
      else
      {
        if(typeof _this.audio == 'object' && 'source' in _this.audio)
        {
          _this.audio={};
        }
      }
      return;
    }
    let function__initAudio = async function(){
      let _audio = {};
      _audio.Ctx = new AudioContext();
      _audio.source = new AudioBufferSourceNode(_audio.Ctx);
      _audio.initiator_url=_url;
      if('onStop' in _this.hooks && typeof _this.hooks.onStop === 'function')
      {
        _audio.initiator_onStop=_this.hooks.onStop;
      }
      return _audio;
    }
    let function__isrunning = async function(thisOnly=true)
    {
      let audio = await function__getAudioObject();
      if(typeof audio === 'object' && 'Ctx' in audio)
      {
        _this._log('debug','function__isrunning',audio.Ctx.state);
        if (audio.Ctx.state === "running")
        {
          if(thisOnly)
          {
            if(audio.initiator_url === _url)
            {
              return true;
            }
          }
          else
          {
            return true;
          }
        }
      }
      return false;
    }
    let function__stop = async function(callback, thisOnly=false)
    {
      try
      {
        let audio = await function__getAudioObject();
        if(thisOnly)
        {
          if(!function__isrunning(true))
          {
            return false;
          }
        }

        if(typeof audio === 'object' && 'source' in audio && 'Ctx' in audio)
        {
          if(audio.Ctx.state === "running")
          {
            try
            {
              audio.source.stop(0);
            }
            catch(ex)
            {
              _this._log('error','function__stop(audio.source.stop)',ex);
            }
          }
          await audio.Ctx.close();
          if(typeof callback == 'function')
          {
            callback();
          }
          else
          {
            if('initiator_onStop' in audio && typeof audio.initiator_onStop === 'function')
            {
              try
              {
                audio.initiator_onStop();
              }
              catch(ex)
              {
                _this._log('error','function__stop',ex);
              }
            }
          }
          await function__destroyAudioObject();
        }
        return true;
      }
      catch(ex)
      {
        throw ex;
      }
    }
    let function__play = async function(callback){
      try
      {
        await function__stop();
        let audio = await function__getAudioObject(true);
        let request = await _this.dsbClient.content.getRawRequestClient(_this.service,await _this.getEndpoint());
        request.responseType("arraybuffer");
        request.onload(function(res){
          let audioData = res;
          try
          {
            audio.Ctx.decodeAudioData(
              audioData,
              (buffer) => {
                audio.audioLength = buffer.duration;
                audio.source.buffer = buffer;
                //_this.audio.source.playbackRate.value = playbackControl.value;
                audio.source.connect(audio.Ctx.destination);
                //audio.source.loop = true;
                audio.source.start(0);
                let ended_event__function = async function(){
                  console.error('@ended_event__function');
                  await function__stop();
                };
                audio.source.addEventListener('ended',ended_event__function,{once: true});

                window.dispatchEvent(new CustomEvent('fw-workspace-trigger_event', {'detail':{'event':'audio_play','source':_this}}));
                window.dispatchEvent(new CustomEvent('dsb-pwa-page_event', {detail:{
                  'event_type':'page_audio',
                  'data': {
                    'action':'play',
                    'id':_this.post_id,
                  }
                }}));
                console.error('@audio_meta',{'audio_meta':_this.audio_meta,'audio.audioLength':audio.audioLength});

                if(typeof callback == 'function')
                {
                  callback();
                }
                /**
                audio.Ctx.onstatechange = function () {
                  console.log('state....',audio.Ctx.state);
                };
                */

                /**
                loopstartControl.setAttribute("max", Math.floor(_this.audio.audioLength));
                loopendControl.setAttribute("max", Math.floor(_this.audio.audioLength));
                */
              },
              (ex) => {
                _this._log('error','function__play.decodeAudioData',ex);
                _this.hooks.onError(ex);
              }
            );
          }
          catch(ex)
          {
            _this.hooks.onError(ex);
          }
        });

        request.send();
      }
      catch(ex)
      {
        throw ex;
      }
    }

    try
    {
      switch(value)
      {
        case "reset":
          return await function__stop(callback);
        case "isRunning":
          return await function__isrunning();
        case "stop":
          return await function__stop(callback);
          break;
        case "play":
          return await function__play(callback);
        default:
          break;
      }
    }
    catch(ex)
    {
      throw ex;
    }
  }

  async connectedCallback() {
    let copy = this.innerHTML;
    let _this = this;

    if(await this.hasAudio())
    {
      if(!(this.delegate instanceof HTMLElement))
      {
        if(!('onPlay' in _this.hooks))
        {
          this.delegate = document.createElement("span");
          this.delegate.innerHTML='Play';
          this.append(this.delegate);
          _this.hooks = {};
          _this.hooks.onPlay=function(){
            this.delegate.innerHTML='Play';
          }
          _this.hooks.onStop=function(){
            this.delegate.innerHTML='Stop';
          }
        }
      }

      let default_state = 'stop';
      if(await this.action('isRunning'))
      {
        _this._log('debug','function__isrunning','action == play');
        default_state = 'play';
        if(typeof _this.hooks.showPlay === 'function')
        {
            _this.hooks.showPlay();
        }
        else if(typeof _this.hooks.onPlay === 'function')
        {
            _this.hooks.onPlay();
        }
      }

      if(!('onError' in _this.hooks) || (typeof _this.hooks.onError !== 'function'))
      {
       _this.hooks.onError = function(){
         window.dispatchEvent(new CustomEvent('fw-workspace-trigger_message', {'detail':{'message':'Sorry, cannot play audio. Please try again later.','icon':'done','action':'auto_close-2000'}}));
        };
      }


      this.delegate.setAttribute('data-dsb-audio',default_state)

      this.delegate.onclick = async () => {
        try
        {
          let state = this.delegate.getAttribute('data-dsb-audio')
          if(state == 'stop')
          {
            _this.delegate.setAttribute('data-dsb-audio','play')
            if(typeof _this.hooks.onLoading === 'function')
            {
              _this.hooks.onLoading();
            }

            if(typeof _this.hooks.onPlay === 'function')
            {
              await _this.action('play',_this.hooks.onPlay);
            }
            else
            {
              await _this.action('play');
            }
          }
          else
          {
            _this.delegate.setAttribute('data-dsb-audio','stop')
            if(typeof _this.hooks.onStop === 'function')
            {
               await _this.action('stop',_this.hooks.onStop);
            }
            else
            {
              await _this.action('stop');
            }
          }
        }
        catch(ex)
        {
          _this._log('error','this.delegate.onclick',ex);
          await _this.action('reset');
          _this.hooks.onError();
        }

      };

      //let this.player = document.createElement("div");
    }
  }
}

